import { forwardRef, cloneElement } from "react";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefinityIcon = forwardRef((props, ref) => {
	return cloneElement(/* @__PURE__ */ _jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 23 21",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#3edaca",
				d: "M6.834 5.664H18.61c1.032 0 1.876.845 1.876 1.876a1.882 1.882 0 0 1-1.876 1.876H6.834A1.882 1.882 0 0 1 4.957 7.54c0-1.032.845-1.876 1.877-1.876"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#78dbdb",
				d: "M1.876 0h3.5C6.41 0 7.254.844 7.254 1.876a1.882 1.882 0 0 1-1.876 1.876h-3.5A1.882 1.882 0 0 1 0 1.876C0 .844.844 0 1.876 0M10.139 0h.063c1.032 0 1.877.844 1.877 1.876a1.882 1.882 0 0 1-1.877 1.876h-.063a1.882 1.882 0 0 1-1.876-1.876C8.263.844 9.107 0 10.139 0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#23aeb1",
				d: "M20.367 11.328H1.877A1.882 1.882 0 0 0 0 13.204c0 1.032.845 1.876 1.876 1.876h18.491a1.882 1.882 0 0 0 1.877-1.876 1.882 1.882 0 0 0-1.877-1.876"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3edaca",
				d: "M1.876 5.664h.064c1.032 0 1.876.844 1.876 1.876A1.882 1.882 0 0 1 1.94 9.416h-.064A1.882 1.882 0 0 1 0 7.54c0-1.032.844-1.876 1.876-1.876"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#78dbdb",
				d: "M15 0h.063c1.032 0 1.876.844 1.876 1.876a1.882 1.882 0 0 1-1.876 1.876H15a1.882 1.882 0 0 1-1.876-1.876C13.124.844 13.968 0 15 0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#007c7c",
				d: "M15.063 16.992h-8.23c-1.03 0-1.876.845-1.876 1.876 0 1.03.845 1.876 1.877 1.876h8.229a1.882 1.882 0 0 0 1.876-1.876 1.883 1.883 0 0 0-1.876-1.876M1.94 16.992h-.064A1.882 1.882 0 0 0 0 18.868c0 1.032.844 1.876 1.876 1.876h.064a1.882 1.882 0 0 0 1.876-1.876 1.882 1.882 0 0 0-1.876-1.876"
			})
		]
	}), {
		...props,
		ref
	});
});
export default SvgDefinityIcon;
